import React from "react";
import UnifiedFormComponent from "./components/UnifiedFormComponent";

const LaporanCekLokasi = () => {
  const handleSuccess = (result) => {
    console.log('Cek Lokasi data saved successfully:', result);
  };

  const handleError = (error) => {
    console.error('Error saving Cek Lokasi data:', error);
  };

  return (
    <UnifiedFormComponent 
      formType="ceklokasi"
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default LaporanCekLokasi;
